import React from "react";
import { Container } from "react-bootstrap";
import "./OurServices.css";
import mobIcon from "../../../Asset/mobile-apps-1.svg";
import webDev from "../../../Asset/web-development (1).svg";
import aiDev from "../../../Asset/ai-development-1.svg";
import uiUx from "../../../Asset/ui-ux-design-1.svg";
import cloud from "../../../Asset/cloud-services.svg";
import hire from "../../../Asset/hire-dedicated-developers-1.svg";
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    img: mobIcon,
    title: "Mobile App Development",
    link: "/Services/mobileApp",
    description:
      "Get cutting-edge and adaptable mobile app development solutions that are designed to deliver exceptional quality and unlock new business opportunities.",
  },
  {
    img: webDev,
    title: "Web App Development",
    link: "/Services/webDevelopment",
    description:
      "Our team delivers an array of web app development services focused on addressing your business challenges, such as web app migration, prototyping, and more.",
  },
  {
    img: aiDev,
    title: "AI & IoT Development",
    link: "/ai",
    description:
      "We specialize in developing and delivering state-of-the-art AI & wearable applications that provide a comprehensive customer experience from every angle.",
  },
  {
    img: uiUx,
    title: "UI/UX Design",
    link: "/Services/uiUx",
    description:
      "Our team has a proven record of turning creative concepts into practical solutions and bringing them to reality through innovation and purpose.",
  },
  {
    img: cloud,
    title: "Cloud Computing",
    link: "/ai",
    description:
      "Reach optimal business outcomes through our expertise in cloud adoption. Our cloud consulting services & solutions deliver everything you need to enrich your abilities for the future.",
  },
  {
    img: hire,
    title: "Hire Developers",
    link: "/Services/dedicatedDevelopers",
    description:
      "Build your dedicated remote development team by offering an affordable price while ensuring the best consulting services. Manage your projects according to your unique requirements.",
  },
];

const Services = () => {
  const navigate = useNavigate();
  return (
    <section className="our-Services-sec">
      <Container>
        <div className="top-text-services">
          <h2>
            OUR <span>SERVICES</span>
          </h2>
        </div>
        <div className="card-items row">
          {servicesData.map((service, index) => (
            <div className="col-sm-6 col-md-6 col-lg-4 mb-4" key={index}>
              <div
                className="card-item"
                onClick={() => {
                  navigate(service.link);
                }}
              >
                <div className="card-img">
                  <img src={service.img} alt={service.title} />
                </div>
                <div className="card-content">
                  <h3>{service.title}</h3>
                  <div className="sort-info">{service.description}</div>
                  <div className="more-link">
                    <p className="link">
                      <span>learn more</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Services;
